module.exports = __webpack_public_path__ + "img/pengumuman.f91519c.png";